import ststisticServices from '../../services/ststistic';
// import Ststistic from '../../model/ststistic';

export const state = {
    ststistic: {},
}

export const mutations = {
    setStstistic(state, ststistic) {
        state.ststistic = ststistic
    }
}

export const getters = {
    getStstistic(state) {
        return state.ststistic;// new Ststistic(state.ststistic);
    }
}

export const actions = {
    getAll({commit}, data = {}){
        return ststisticServices.getAll(data)
        .then((response)=>{
            commit('setStstistic', response.data.data)
            return response
        })
    },
}